import { $, $$ } from 'utils/dom';
import FocusTrap from 'modules/focus-trap';

class OffscreenNavigation {
  constructor(handler, target, closeButton) {
    this.handler = handler;
    this.target = target;
    this.anchors = $$('a', target);
    this.closeButton = closeButton;
    this.focusableElements = $$(
      'a[href]:not([disabled]), button:not([disabled])',
      target
    );
  }

  setClasses = () => {
    this.handler.classList.toggle('is-open');
    this.target.classList.toggle('is-open');
  };

  closeNavigation = () => {
    this.handler.classList.remove('is-open');
    this.target.classList.remove('is-open');
  };

  setAttributes = () => {
    if (this.handler.getAttribute('aria-expanded') === 'false') {
      this.handler.setAttribute('aria-expanded', 'true');
    } else {
      this.handler.setAttribute('aria-expanded', 'false');
    }

    if (this.target.getAttribute('aria-hidden') === 'false') {
      this.target.setAttribute('aria-hidden', 'true');
    } else {
      this.target.setAttribute('aria-hidden', 'false');
    }
  };

  setTabindex = () => {
    this.focusableElements.forEach(element => {
      if (element.getAttribute('tabindex') === '-1') {
        element.setAttribute('tabindex', '0');
      } else {
        element.setAttribute('tabindex', '-1');
      }
    });
  };

  init = () => {
    this.focusableElements.forEach(element => {
      element.setAttribute('tabindex', '-1');
    });

    this.handler.addEventListener('click', () => {
      this.setClasses();
      this.setAttributes();
      this.setTabindex();
    });

    this.anchors.forEach(anchor => {
      anchor.addEventListener('click', () => {
        this.closeNavigation();
        this.setAttributes();
        this.setTabindex();
      });
    });

    this.closeButton.addEventListener('click', () => {
      this.closeNavigation();
      this.setAttributes();
      this.setTabindex();
    });

    window.addEventListener('keydown', event => {
      if (event.key === 'Escape' && this.target.classList.contains('is-open')) {
        this.closeNavigation();
        this.setAttributes();
        this.setTabindex();
      }
    });
  };
}

const landingOpenButton = $('.landingpage-navigation__open');
const landingNav = $('.landingpage-navigation__nav');
const landingCloseButton = $('.landingpage-navigation__nav-close');

if (landingOpenButton && landingNav && landingCloseButton) {
  new OffscreenNavigation(
    landingOpenButton,
    landingNav,
    landingCloseButton
  ).init();

  new FocusTrap(landingOpenButton, landingNav, landingCloseButton).init();
}

const fixedOpenButton = $('.fixed-navigation__open');
const fixedNav = $('.fixed-navigation__nav');
const fixedCloseButton = $('.fixed-navigation__nav-close');

if (fixedOpenButton && fixedNav && fixedCloseButton) {
  new OffscreenNavigation(fixedOpenButton, fixedNav, fixedCloseButton).init();
  new FocusTrap(fixedOpenButton, fixedNav, fixedCloseButton).init();
}
